import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {UntypedFormControl} from '@angular/forms';
import {City} from '@models/city';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';
import * as $ from 'jquery';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-config-city-tools',
    templateUrl: './config-city-tools.component.html',
    styleUrls: ['./config-city-tools.component.scss']
})
export class ConfigCityToolsComponent implements OnInit {

    needConfig = true;

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    cityControl = new UntypedFormControl();
    cities: City[] = [];
    name = ""

    constructor(
        public authService: AuthenticationService,
        public cityService: CityService,
        public adService: AdService,
        public deviceService: DeviceDetectorService,
        public commonService: CommonService) {
    }

    ngOnInit(): void {
        document.body.style.overflowY = "hidden";
        if (this.deviceService.isMobile()) {
            setTimeout(function() {
                window.scrollTo({top: 0});
                $("app-ad-widgets").height(document.getElementsByClassName("need-config")[0].clientHeight - 80);
                $("app-ad-widgets").css("overflow", "hidden");
            }, 200);
        }
        if (this.favorite.ad_city.slug != '') {
            this.needConfig = false;
            document.body.style.overflowY = "auto";
            $("app-ad-widgets").css("height", "auto");
            $("app-ad-widgets").css("overflow", "inherit");
        } else {
            this.cityControl.valueChanges
                .pipe(
                    startWith(''),
                    debounceTime(500),
                    // tap(() => this.isLoading = true),
                    switchMap(value => this.cityService.searchCommune(this.name))
                    // .pipe(finalize(() => this.isLoading = false))
                )
                .subscribe(d => {
                    $('.citySpinner').hide();
                    this.cities = d;
                });
        }
    }

    changeCity(value) {
        this.cityService.getCity(value.city_code).subscribe(c => {
            if (!c) {
                // Le champ affiche l'objet ville choisi (ngModel) : on le vide
                this.name = '';
                return;
            }
            this.favorite.ad_city = c;
            if (this.favorite.ad_city.carac_commune) {
                this.favorite = this.adService.cleanInput(this.favorite);
                this.favorite = this.adService.updateValues(this.favorite);
                this.favoriteChange.emit();
                this.needConfig = false;
                document.body.style.overflowY = "auto";
                $("app-ad-widgets").css("height", "auto");
                $("app-ad-widgets").css("overflow", "inherit");
            }
        });
    }

    showResults() {
        if (this.favorite.ad_city != undefined && this.favorite.ad_city.name != '') {
            this.needConfig = false;
            document.body.style.overflowY = "auto";
            $("app-ad-widgets").css("height", "auto");
            $("app-ad-widgets").css("overflow", "inherit");
        }
    }
}
